import { getStore } from '../store/Store';

/**
 * returns true if the size of the folderTable map is 0, else false
 */
export const isFolderTableEmpty = (): boolean => !getStore().folders.folderTable.size;
